module.exports = __webpack_public_path__ + "img/21_54.0ac41d4a.png";